module.exports = __webpack_public_path__ + "static/media/profile.b2b06e3d.png";